const post = {
  id: "reading-watching-april-2026",
  title: "Reading and Watching, April 2026",
  publication: "Personal Blog, 2026",
  date: "2026-04-11",
  summary: "What I have been reading and watching this month.",
  content: `

## Reading

**[What 2026 Looks Like](https://www.alignmentforum.org/posts/6Xgy6CAf2jqHhynHL/what-2026-looks-like)**

This forecasting piece was written in 2021 by Daniel Kokotajlo, the author of [AI 2027](https://ai-2027.com/). As with all forecasts, it should be wrong. What is interesting, however, is ways in which it is right. I wanted to see where it lands in 2026 and compare it to where we are now. 

Unfortunately, it seems as though this forecast was not sufficiently bullish on AI progress.  

---

**[Thucydides - The Peloponnesian War](https://www.gutenberg.org/files/7142/7142-h/7142-h.htm)**

I have two long-haul flights to take this month, and I _truly hope_ I will get through a greater portion of this book than I have done so far.

---

**[Cummings - People, Ideas, Machines XV: TS Eliot on culture, religion, class, elites, education, 'progressives'](https://dominiccummings.substack.com)**

---

**[Peter Thiel - The Straussian Moment (2019)](https://gwern.net/doc/politics/2007-thiel.pdf)**

---

**[The Anti-Promethean Backlash - Brink Lindsey](https://brinklindsey.substack.com/p/the-anti-promethean-backlash)**

---

**[The Case for a Less-Effective Altruism - NYT](https://www.nytimes.com/2022/11/18/opinion/effective-altruism.html)**

As someone who is working for an EA-aligned organisation, I think it is important to try to deeply understand and sympathise with good faith criticisms of this movement. I often think of the quote from this piece when reflecting on effective altruism:

> Picture effective altruists sitting around in a San Francisco skyscraper calculating how to relieve suffering halfway around the world while the city decays beneath them.

---

**[Sam Altman May Control Our Future—Can He Be Trusted?](https://archive.is/FbAiL#selection-2061.0-2083.407)**

> As the technology became increasingly powerful, we learned, about a dozen of OpenAI’s top engineers held a series of secret meetings to discuss whether OpenAI’s founders, including Brockman and Altman, could be trusted. At one, an employee was reminded of a sketch by the British comedy duo Mitchell and Webb, in which a Nazi soldier on the Eastern Front, in a moment of clarity, asks, “Are we the baddies?”

---

## Watching

**Should Governments or Markets Control AI? — Dean Ball x Daniel Kokotajlo**

<iframe width="100%" height="400" src="https://www.youtube.com/embed/wkPsbwzyOa8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

> "If I have to pick the trade-off between, on the one hand, a usurpation of power by this group of people from the U.S. government versus, on the other hand, the U.S. government sort of taking over the world, which one do I pick? Ultimately, I side with the West Coast. I think that we will build new, healthier institutions together, better, but that's an optimistic view, and I could be wrong. I will actually just say that my assessment of the quality of Silicon Valley elites was much higher three years ago than it is today. I think they're much lower quality than I realised. They understand how the world works way, way less well than I realised, so I'm updating here too." <br>
*- Dean Ball, former Senior Policy Advisor for Artificial Intelligence and Emerging Technology at the White House Office of Science and Technology Policy.*

---

**Conner O'Malley - Stand Up Solutions (Full Special)**

<iframe width="100%" height="400" src="https://www.youtube.com/embed/Svual-PcOxE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

---

**Building The First Biotech Prime — Jake Adler, CEO Pilgrim**

<iframe width="100%" height="400" src="https://www.youtube.com/embed/Vxj41-p8xyo?start=116" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

`
};

export default post;
